import { css, html, LitElement } from "lit"
import "./ListePokemons.js"

export default class MaRecherche extends LitElement {
  static properties = { listePokemonsRecherchee: { type: Array }, estModeAmis: { type: Boolean } }

  static styles = css``

  constructor() {
    super()
    this.listePokemonsRecherchee = []
    this.estModeAmis = false
  }

  render() {
    return html`
        <p-liste-pokemons .listePokemons=${this.listePokemonsRecherchee} .estModeAmis=${this.estModeAmis}></p-liste-pokemons>
        `
  }
}
customElements.define("p-ma-recherche", MaRecherche)
